import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import ReactFlow, { Controls, Background, MarkerType } from 'reactflow';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import Const from '../../../../util/Constants';
import withRouter from '../../../../util/WithRouter';
import MainCondition from '../../condition/MainCondition';
import FieldAcessControl from './FieldAcessControl';
import FieldOptionControl from './FieldOptionControl';
import AutomationAssigmnent from '../../automation/AutomationAssigmnent';
import FieldController from '../../../../controller/FieldController';
import ApiUiController from '../../../../controller/ApiUiController';
import ConditionalFieldAPI from '../../../../api/ConditionalFieldAPI';
import Util from '../../../../util/Util';

import Initial from './NodeInitial';
import Visibility from './NodeVisibility';
import Condition from './NodeCondition';
import Option from './NodeOption';
import Value from './NodeValue';
import Sidebar from './Sidebar';

import './dnd.css';

class ConditionalField extends React.Component {

  static Types = { 
    initial: Initial,
    visibility: Visibility,
    condition: Condition,
    option: Option,
    value: Value
  };

  static MarkerEnd = { type: MarkerType.ArrowClosed, color: '#FF0072' };
  static Style = { strokeWidth: 2, stroke: '#FF0072' };

  static MarkerEndLeft = { type: MarkerType.ArrowClosed, color: '#FF0000' };
  static StyleLeft = { strokeWidth: 2, stroke: '#FF0000' };

  static MarkerEndRight = { type: MarkerType.ArrowClosed, color: '#00FF00' };
  static StyleRight = { strokeWidth: 2, stroke: '#00FF00' };

  static Initial = {
    id: 'n-1',
    type: 'initial',
    data: { id: 1, label: `Trigger on ${this.fieldName} change` },
    position: { x: 250, y: 5 },
  };

  constructor(props) {
    super(props);

    this.fieldId = parseInt(props.match.params.fieldId);
    this.options = [];
    this.i = -1;

    const model = reactLocalStorage.getObject(Const.Model);
    const keys = Object.keys(model);
    for(let i = 0; i < keys.length; i++) {
      const fields = model[keys[i]].fields;
      if(fields === undefined) {
        continue;
      }

      const fieldKeys = Object.keys(fields);
      let j = 0;
      for(; j < fieldKeys.length; j++) {
        if(parseInt(fields[fieldKeys[j]].id) === this.fieldId) {
          this.fieldName = fields[fieldKeys[j]].label_name;
          this.model = model[keys[i]];
          break;
        }
      }

      if(j < fieldKeys.length) {
        break;
      }
    }

    this.fields = FieldController.getFilterFields(this.model.fields);

    this.id = 1;
    this.instance = null;
    this.wrapper = React.createRef();
    const nodes = [
      { ...ConditionalField.Initial,
        data: { ...ConditionalField.Initial.data, label: `Trigger on ${this.fieldName} change` }
      }
    ];
    const edges = [];
    this.state = { change: true, inApiCall: true, popup: '', id: 0, nodes, edges };

    this.conditions = [];
    this.acessFields = [];
    this.fieldOptions = [];
    this.fieldValues = [];
  }

  componentDidMount() { ConditionalFieldAPI.get(this.roleId, this.fieldId, this.onReceived, this.onFail); }

  onReceived = res => {
    const id = res.id ? res.id : 0;
    const nodes = res.conditional_field ? res.conditional_field.nodes 
      : [
          { ...ConditionalField.Initial,
            data: { ...ConditionalField.Initial.data, label: `Trigger on ${this.fieldName} change` }
          }
        ];
    this.id = Math.max.apply(Math, nodes.map(node => parseInt(node.id.replace('n-', ''))));
    const edges = res.conditional_field ? res.conditional_field.edges : [];
    this.setState({ ...this.state, inApiCall: false, id, nodes, edges });
  }

  onInit = instance => this.instance = instance;
  onDragOver = event => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }
  onDrop = event => {
    event.preventDefault();
    const reactFlowBounds = this.wrapper.current.getBoundingClientRect();
    const type = event.dataTransfer.getData('application/reactflow');
    const position = this.instance.screenToFlowPosition({
      x: event.clientX - reactFlowBounds.left,
      y: event.clientY - reactFlowBounds.top,
    });
    this.id++;
    const node = {
      id: `n-${this.id}`,
      type,
      position,
      data: { id: this.id, label: `${type} node` }
    };
    this.setState({ ...this.state, nodes: [ ...this.state.nodes, node ]});
  };
  onNodeDrag = (event, node) => {
    event.preventDefault();
    const reactFlowBounds = this.wrapper.current.getBoundingClientRect();
    const position = this.instance.screenToFlowPosition({
      x: event.clientX - reactFlowBounds.left - 100,
      y: event.clientY - reactFlowBounds.top + (40/2)
    });
    const nodes = [ ...this.state.nodes ];
    const changedNode =  nodes.find(item => item.id === node.id);
    changedNode.position = position;
    this.setState({ ...this.state, nodes });
  }
  onNodesDelete = nodes => this.setState({ ...this.state,
    nodes: [ ...this.state.nodes ].filter(i => i.id !== 'id-1' && nodes.find(j => j.id !== i.id)),
    edges: [ ...this.state.edges ].filter(i => nodes.find(j => j.id !== i.source && j.id !== i.target)) });
  onEdgesDelete = edges => this.setState({ ...this.state,
    edges: [ ...this.state.edges ].filter(i => edges.find(j => j.id !== i.id)) });
  onConnect = edge => {
    if(edge.sourceHandle === 'left') {
      this.setState({ ...this.state, edges: [ ...this.state.edges, 
        { id: `e-${edge.source}-${edge.target}`, source: edge.source, target: edge.target,
          markerEnd: ConditionalField.MarkerEndLeft, style: ConditionalField.StyleLeft,
          sourceHandle: edge.sourceHandle }]});
    } else if(edge.sourceHandle === 'right') {
      this.setState({ ...this.state, edges: [ ...this.state.edges, 
        { id: `e-${edge.source}-${edge.target}`, source: edge.source, target: edge.target,
          markerEnd: ConditionalField.MarkerEndRight, style: ConditionalField.StyleRight,
          sourceHandle: edge.sourceHandle }]});
    } else {
      const isAlredyAdded = this.state.edges.find(i => i.source === edge.source);
      if(!isAlredyAdded) {
        this.setState({ ...this.state, edges: [ ...this.state.edges, 
          { id: `e-${edge.source}-${edge.target}`, source: edge.source, target: edge.target,
            markerEnd: ConditionalField.MarkerEnd, style: ConditionalField.Style }]});
      }
    }
  }

  onNodeClick = (_, node) => {
    this.activeNode = node.id;
    if(node.type === 'condition') {
      this.conditions = node.data && node.data.conditions ? node.data.conditions : [];
    } else if(node.type === 'visibility') {
      this.acessFields = node.data && node.data.acessFields ? node.data.acessFields : [];
    } else if(node.type === 'option') {
      this.fieldOptions = node.data && node.data.fieldOptions ? node.data.fieldOptions : [];
    } else if(node.type === 'value') {
      this.fieldValues = node.data && node.data.fieldValues ? node.data.fieldValues : [];
    }
    this.setState({ ...this.state, popup: node.type});
  }

  onConditionChanged = conditions => this.conditions = conditions;
  onSaveCondition = () => {
    const nodes = [ ...this.state.nodes ];
    this.conditions = this.conditions.filter(item => Object.keys(item).length !== 0)
      .map(filter => { return { field: filter.field.value,
        type: filter.field.type, condition: filter.condition.value, value: filter.value }});
    nodes.find(node => node.id === this.activeNode).data['conditions'] = [ ...this.conditions ];
    this.conditions = [];
    this.setState({ ...this.state, nodes, popup: '' });
  }

  onAcessChanged = fields => this.acessFields = fields;
  onSaveAcess = () => {
    const nodes = [ ...this.state.nodes ];
    nodes.find(node => node.id === this.activeNode).data['acessFields'] = [ ...this.acessFields ];
    this.acessFields = [];
    this.setState({ ...this.state, nodes, popup: '' });
  }

  onOptionsChanged = fields => this.fieldOptions = fields;
  onSaveOptions = () => {
    const nodes = [ ...this.state.nodes ];
    nodes.find(node => node.id === this.activeNode).data['fieldOptions'] = [ ...this.fieldOptions ];
    this.fieldOptions = [];
    this.setState({ ...this.state, nodes, popup: '' });
  }

  editAssign = (index, assigment) => this.fieldValues[index] = assigment;
  addAssign = () => {
    this.fieldValues.push({});
    this.setState({ ...this.state, change: !this.state.change });
  }
  deleteAssign = index => {
    this.fieldValues = this.fieldValues.filter((_, i) => i !== index);
    this.setState({ ...this.state, change: !this.state.change });
  }
  onSaveValues = () => {
    const nodes = [ ...this.state.nodes ];
    nodes.find(node => node.id === this.activeNode).data['fieldValues'] = [ ...this.fieldValues ];
    this.fieldValues = [];
    this.setState({ ...this.state, nodes, popup: '' });
  }

  onSave = () => {
    const body = { id: this.state.id, role: this.roleId, 
      model: this.model.model_no, field_id: this.fieldId, 
      conditional_field: { nodes: this.state.nodes, edges: this.state.edges }};
    ConditionalFieldAPI.save(body, this.onSaved, this.onFail);
  }
  onSaved = () => {
    Util.showNotification('Successful', 'Conditional added successfully.', 'success');
    this.props.navigate(this.props.match.path.substring(0, 
      this.props.match.path.indexOf('conditional')) + this.model.model_no);
  }

  render() {
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <Modal aria-labelledby="contained-modal-title-vcenter" size="lg" centered
          show={this.state.popup}
          onHide={() => this.setState({ ...this.state, popup: '' })}
          onExit={() => this.setState({ ...this.state, popup: '' })}>
          <Modal.Body>
            { this.state.popup === 'condition'
              ? <div>
                  <MainCondition model={this.model} fields={this.fields} eKey="conditions"
                    value={this.conditions} onConditionChanged={this.onConditionChanged} />
                  <Button variant="success" onClick={this.onSaveCondition}>Save</Button>
                </div>
              : null
            }

            { this.state.popup === 'visibility'
              ? <div>
                  <FieldAcessControl model={this.model} fields={this.fields} eKey="fields"
                    value={this.acessFields} onAcessChanged={this.onAcessChanged} />
                  <Button variant="success" onClick={this.onSaveAcess}>Save</Button>
                </div>
              : null
            }

            { this.state.popup === 'option'
              ? <div>
                  <FieldOptionControl model={this.model} fields={this.fields} eKey="fields"
                    value={this.fieldOptions} onOptionsChanged={this.onOptionsChanged} />
                  <Button variant="success" onClick={this.onSaveOptions}>Save</Button>
                </div>
              : null
            }

            { this.state.popup === 'value'
              ? <div>
                  <AutomationAssigmnent fields={this.fields}
                    assigments={this.fieldValues} model={this.model}
                    onAdd={this.addAssign} onEdit={this.editAssign} onDelete={this.deleteAssign}/>
                  <Button variant="success" onClick={this.onSaveValues}>Save</Button>
                </div>
              : null
            }
          </Modal.Body>
        </Modal>
          
        <div style={{ height: 500 }}>
          <div className="dndflow">
            <div className="reactflow-wrapper" ref={this.wrapper}>
              <ReactFlow
                onInit={this.onInit}
                nodeTypes={ConditionalField.Types}
                nodes={this.state.nodes}
                edges={this.state.edges}
                onDrop={this.onDrop}
                onDragOver={this.onDragOver}
                onNodeDrag={this.onNodeDrag}
                onConnect={this.onConnect}
                onNodesDelete={this.onNodesDelete}
                onEdgesDelete={this.onEdgesDelete}
                onNodeClick={this.onNodeClick}
              >
                <Controls />
                <Background variant="dots" gap={12} size={1} />
              </ReactFlow>
            </div>
            <Sidebar onSave={this.onSave} />
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ConditionalField);